/**
 * @param {*} value
 * @returns {string|undefined}
 */
function ssn (value) {
  if (!value) return

  let val = value
    .toString()
    .trim()
  const centurySign = val.indexOf('+') >= 0 ? '+' : '-'

  // Remove all non digits or + -
  val = val.replace(/[^0-9+-]+/g, '')

  // Set a tempValue and remove all non digits
  const tempValue = val.replace(/[^0-9]+/g, '')

  const beginsWithCentury = ['19', '20'].includes(tempValue.substring(0, 2))

  if (tempValue.length === 10 && !beginsWithCentury) {
    return tempValue.substring(0, 6) + centurySign + tempValue.substring(6, 10)
  }

  // Handle full year
  if (tempValue.length === 12 && beginsWithCentury) {
    return tempValue.substring(0, 8) + centurySign + tempValue.substring(8, 12)
  }

  if (tempValue.length > 12) {
    return tempValue.substring(0, 13)
  }

  return val
}

module.exports = { ssn }
